import { dataTableParamsBuilder } from "../../utils/data-table-params-builder";
import { usePaginationQuery } from "../../utils/hooks/use-pagination-query";
import { http } from "../../utils/http";

function fetchHospitalPoint(params, id) {
  const baseUrl = window.location.origin;
  const endpointUrl = new URL(
    `/admin/point-histories?hospitalId=${id}`,
    baseUrl
  );

  if (params.type) {
    endpointUrl.searchParams.append("type", params.type);
  }

  if (params.address) {
    endpointUrl.searchParams.append("address", params.address);
  }

  if (params.contact) {
    endpointUrl.searchParams.append("contact", params.contact);
  }

  if (params.email) {
    endpointUrl.searchParams.append("email", params.email);
  }

  dataTableParamsBuilder({
    searchParams: endpointUrl.searchParams,
    filterValues: [params.order],
    ...params,
  });

  return http(endpointUrl.toString().replace(baseUrl, ""));
}

export function useHospitalPointlist(params = {}, id) {
  return usePaginationQuery(
    [
      "hospital-point",
      id,
      params.type,
      params.address,
      params.contact,
      params.email,
    ],
    (paginationState) =>
      fetchHospitalPoint({ ...params, ...paginationState }, id)
  );
}
